import { ImLab } from "react-icons/im";

import BtnTemplate from "../BtnTemplate";

import { useLocation, useNavigate } from "react-router-dom";

import Tooltip from "../../ToolTip";

const Investigations = ({ open = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const id = "investigation-tooltip";

  return (
    <div data-tip data-for={id} className="w-full">
      <BtnTemplate
        label={"Investigations"}
        open={open}
        active={location.pathname.includes("dashboard/investigations")}
        click={() => navigate("investigations")}
      >
        <ImLab />
      </BtnTemplate>
      <Tooltip id={id} txt1="Investigation Management" txt2="in one spot">
        <ImLab />
      </Tooltip>
    </div>
  );
};

export default Investigations;
